import Encoding from '@/ts/loadData/encoding.js'

export const importFile = (file) => {
  return new Promise(function (resolve) {
    file.arrayBuffer().then(buffer => {
      let array = new Uint8Array(buffer)
      // 文字コードを取得
      switch (Encoding.detect(array)) {
        case 'UTF16':
          // 16ビット符号なし整数値配列と見なす
          array = new Uint16Array(buffer)
          break
        case 'UTF32':
          // 32ビット符号なし整数値配列と見なす
          array = new Uint32Array(buffer)
          break
      }
      let detectedEncoding = Encoding.detect(array)
      detectedEncoding = (detectedEncoding === 'UNICODE') ? 'UTF-8' : detectedEncoding
      console.log(detectedEncoding)
      // Unicodeの数値配列に変換
      const unicodeArray = Encoding.convert(array, 'UNICODE', 'SJIS')
      // Unicodeの数値配列を文字列に変換
      const buf = Encoding.codeToString(unicodeArray)

      resolve(buf)
    })
  })
}

export function convertCsvData (_buf) {
  const buf = _buf.replace(/\r\n/g, '\n')
  let field = ''
  let line = []
  const lines = []
  let startPos = 0
  let endPos = 0
  const bufArray = [...buf]
  const maxPos = bufArray.length

  while (true) {
    // 空白・タブ・カンマを飛ばす
    /*
    while ((startPos < maxPos) && (bufArray[startPos] === ' ' || bufArray[startPos] === '\t' || bufArray[startPos] === ',')) {
      startPos++
    }
    */

    // データの最後の位置を取得
    if (startPos < maxPos && bufArray[startPos] === '"') {
      // "で囲まれているとき
      // 最後の"を探す
      endPos = startPos
      while (true) {
        endPos = buf.indexOf('"', endPos + 1)
        if (endPos < 0) {
          console.log('"が不正')
          return []
        }
        // "が2つ続かない時は終了
        if (endPos + 1 === maxPos || bufArray[endPos + 1] !== '"') {
          break
        }
        // "が2つ続く
        endPos++
      }

      // 一つのフィールドを取り出す
      field = buf.substring(startPos, endPos + 1)
      // ""を"にする
      field = field.substring(1, field.length - 1).replace('""', '"')

      endPos++
      // 空白を飛ばす
      while (endPos < maxPos && bufArray[endPos] !== ',' && bufArray[endPos] !== '\n' && bufArray[endPos] !== '\t') {
        endPos++
      }
    } else {
      // "で囲まれていない
      // カンマか改行の位置
      if (endPos < maxPos - 1) {
        if (bufArray[startPos] === '\t' && bufArray[startPos] === ',') {
          field = ''
          // endPos++
        /*
        if (endPos > 0 && bufArray[endPos] === '\t' && bufArray[endPos + 1] === '\t') {
          field = ''
          endPos++
        } else if (endPos > 0 && bufArray[endPos] === ',' && bufArray[endPos + 1] === ',') {
          field = ''
          endPos++
        */
        } else {
          endPos = startPos

          while (endPos < maxPos && (bufArray[endPos] !== ',') && bufArray[endPos] !== '\n' && bufArray[endPos] !== '\t') {
            endPos++
          }

          // 一つのフィールドを取り出す
          field = buf.substring(startPos, endPos)
        }
      } else {
        endPos++
        field = ''
      }
      // 後の空白を削除
      // field = field.TrimEnd();
    }

    // フィールドの追加
    line.push(field)

    // 行の終了か調べる
    if (endPos >= maxPos || bufArray[endPos] === '\n') {
      // 行の終了
      // レコードの追加
      lines.push(line)
      line = []

      if (endPos >= maxPos) {
        // 終了
        break
      }
    }
    // 次のデータの開始位置
    startPos = endPos + 1
  }
  return lines
}
